import { useState,useEffect } from 'react';
import Downloader from "components/Downloader";
import Layout from "app/(others)/layout";
import "../../styles/styles.css";
import Page404 from "app/not-found";
import axios from "axios";


const API_URL = process.env.REACT_APP_API_URL;
const axiosInstance = axios.create({
  baseURL: API_URL,
  headers: { "Content-Type": "application/json" },
});

const PageMerci = () => {
        return ( 
            <Layout>
            <div className={`nc-PageArchiveAudio `}>
            <div className="centrer container">
                <table>
                    <tbody>
                        <tr>
                            <td>Merci pour votre don!<br></br>
                                Vérifier votre messagerie, un lien vous sera envoyé pour vous enregistrer comme membre du site web.<br></br></td>
                        </tr>
                    </tbody>
                </table>
            </div>
            </div>
            </Layout> 
        );
};
    
export default PageMerci;
    
